import { Pipe, PipeTransform } from '@angular/core';
import { getStyleObjectFromUrl, StyleObject } from '@outlaw/core';

@Pipe({
  name: 'linkBackground',
})
export class LinkBackgroundPipe implements PipeTransform {
  transform(link: string): StyleObject {
    return getStyleObjectFromUrl(link);
  }
}
